<template>
  <div class="switch-button-bar">
    <div
      v-for="(tab_e,tab_k) in contentTabs"
      :key="tab_k"
      class="switch-button"
      :class="{active:isActiviated(tab_e)}"
      @click="contentTabOnclick(tab_e)"
    >
      <p>{{ $t(tab_e.textLabel) }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "SwitchButtonBar",
  props: {
    selectedTabId: {
      type: String,
      default: ""
    },
    contentTabs: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    isActiviated(tab) {
      return this.selectedTabId === tab.id;
    },
    contentTabOnclick(tab) {
      this.$emit("click", tab);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/switch-button-bar";
</style>